// src/components/SocialLinksDisplay.js
import React from 'react';
import { FaLinkedin, FaGithub, FaDribbble, FaLink } from 'react-icons/fa';

const iconMap = {
  linkedin: FaLinkedin,
  github: FaGithub,
  dribbble: FaDribbble,
  website: FaLink,
};

// Same helper function as in SocialLinksForm for consistency
const normalizeUrl = (url) => {
  if (!url) return '';
  
  // If the URL doesn't start with http:// or https://, add https://
  if (!url.match(/^https?:\/\//i)) {
    return `https://${url}`;
  }
  
  return url;
};

const SocialLinksDisplay = ({ socialLinks = [] }) => {
  if (!socialLinks.length) return null;
  return (
    <div className="flex space-x-4 mt-2">
      {socialLinks.map((link, index) => {
        const Icon = iconMap[link.type] || FaLink;
        // Normalize the URL when displaying
        const url = normalizeUrl(link.url);
        
        return (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-sm text-gray-700 hover:text-blue-600"
          >
            <Icon className="mr-1" />
            {link.type.charAt(0).toUpperCase() + link.type.slice(1)}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinksDisplay;
